import React, { useEffect, useState, lazy } from 'react';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { LogoCarousel } from './LogoCarousel';
export function Hero() {
  const {
    t
  } = useLanguage();
  const [isLoaded, setIsLoaded] = useState(false);
  // Trigger animations on mount
  useEffect(() => {
    setIsLoaded(true);
  }, []);
  return <section className="relative overflow-hidden pt-24 pb-0 lg:pt-32 lg:pb-0" data-id="element-203">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 z-10" data-id="element-204">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-205">
          {/* LEFT — Text Content */}
          <div className="w-full lg:w-6/12 text-center lg:text-left order-1 flex flex-col" data-id="element-206">
            <h1 className={`text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight text-white mb-5 leading-[1.1] animate-hidden animate-fade-up delay-100 ${isLoaded ? 'animate-visible' : ''}`} data-id="element-207">
              {t.hero.h1}
            </h1>

            {/* Mobile-only GIF */}
            <div className={`lg:hidden w-full flex justify-center py-6 order-3 animate-hidden animate-fade-in delay-300 ${isLoaded ? 'animate-visible' : ''}`} data-id="element-208">
              <img src="https://cdn.magicpatterns.com/uploads/7ba2e5CHZCbXDvGSMdvNa8/original-aaa8682220d5fd60c715fce6b52f7f3e.gif" alt="AI website builder comparison illustration" width={300} height={300} loading="lazy" decoding="async" className="w-[300px] h-[300px] object-cover" style={{
              maskImage: 'radial-gradient(circle, black 35%, transparent 70%)',
              WebkitMaskImage: 'radial-gradient(circle, black 35%, transparent 70%)'
            }} data-id="element-209" />
            </div>

            <div className={`space-y-4 mb-8 order-4 animate-hidden animate-fade-up delay-200 ${isLoaded ? 'animate-visible' : ''}`} data-id="element-210">
              <p className="text-lg md:text-xl text-gray-300 max-w-xl lg:max-w-none leading-relaxed mx-auto lg:mx-0" data-id="element-211">
                {t.hero.description1}
              </p>
              {t.hero.description2 && <p className="text-base text-gray-400 max-w-xl lg:max-w-none leading-relaxed mx-auto lg:mx-0" data-id="element-212">
                  {t.hero.description2}
                </p>}
            </div>

            <div className={`flex justify-center lg:justify-start order-5 animate-hidden animate-fade-up delay-300 ${isLoaded ? 'animate-visible' : ''}`} data-id="element-213">
              <a href="#rating" className="px-7 py-3.5 bg-accent-blue text-white rounded-xl font-semibold shadow-lg shadow-accent-blue/25 hover:shadow-xl hover:shadow-accent-blue/35 hover:bg-accent-hover transition-colors duration-200 flex items-center justify-center gap-2 text-sm" data-id="element-214">
                {t.hero.cta}
                <ArrowRight className="w-4 h-4" data-id="element-215" />
              </a>
            </div>
          </div>

          {/* RIGHT — GIF Animation (Desktop) — LCP element */}
          <div className={`hidden lg:flex w-full lg:w-6/12 items-center justify-center order-2 animate-hidden animate-fade-in delay-400 ${isLoaded ? 'animate-visible' : ''}`} data-id="element-216">
            <img src="https://cdn.magicpatterns.com/uploads/7ba2e5CHZCbXDvGSMdvNa8/original-aaa8682220d5fd60c715fce6b52f7f3e.gif" alt="AI website builder comparison illustration" width={500} height={500} loading="eager" decoding="async" fetchPriority="high" className="w-[500px] h-[500px] object-cover" style={{
            maskImage: 'radial-gradient(circle, black 35%, transparent 70%)',
            WebkitMaskImage: 'radial-gradient(circle, black 35%, transparent 70%)'
          }} data-id="element-217" />
          </div>
        </div>
      </div>

      {/* Logo Carousel integrated into hero */}
      <div className={`mt-8 lg:mt-4 animate-hidden animate-fade-in delay-500 ${isLoaded ? 'animate-visible' : ''}`} data-id="element-218">
        <LogoCarousel data-id="element-219" />
      </div>
    </section>;
}